import React, { Component } from "react";
import Modal from "../Modal/Modal";
import classes from "../Confirm/Confirm.css";
import { AiFillWarning } from "react-icons/ai";

class Toast extends Component {
	constructor() {
		super();
		this.state = {
			show: false,
		};
		window.toastModalComponent = this;
	}

	render() {
		return (
			<Modal
				show={this.state.show}
				showCloseIcon
				modalClosed={() => this.setState({ show: false })}
			>
				<div style={{ padding: "0.5rem" }}>
					<div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
						<AiFillWarning color="#F93875" size={40} />
						<h2>Error 404</h2>
					</div>
					<p style={{ marginBottom: "2rem" }}>
						Upstream service not available. Please refresh the page and try again. If error persists, please contact
						your supervisor.
					</p>
				</div>
			</Modal>
		);
	}
}

export default Toast;

export class ToastApi {
	constructor() {}

	static show = () => {
		window.toastModalComponent.setState({ show: true });
	};

	static hide = () => {
		window.toastModalComponent.setState({ show: false });
	};
}
